/**
 * The Rules docket's commissioner console — the model, over the shared bar.
 *
 * The bar itself is `Console.tsx`; everything that makes this one the RULES console is
 * `domain/commishConsole.ts`, which decides which of the three acts is next, whether it may fire,
 * and every string either state shows. Splitting them on 26 August was not tidiness: the lottery
 * launcher needed the same bar with a different model, and the docket pass after it needs a third.
 * One geometry, three models.
 */

import {
  consoleModel, type ConsoleAct, type ConsoleInput, type Reversible,
} from '../domain/commishConsole.js';
import { Console } from './Console.js';

export interface CommishConsoleProps extends ConsoleInput {
  /** Who is acting. The bar names him — two people can do this and ten are affected. */
  actor: string;
  /** Dark while the room is in session, so the bar belongs to the screen above it. */
  dark?: boolean;
  /** `itemId` is present for the two acts that name a row — see `consoleModel`. */
  onAct: (act: Exclude<ConsoleAct, null>, itemId?: string) => void;
  onReversible: (id: Reversible['id']) => void;
}

export function CommishConsole(props: CommishConsoleProps) {
  const m = consoleModel(props);
  if (!m.act) return null;

  return (
    <Console
      actor={props.actor}
      dark={props.dark}
      line={m.constraint}
      standing={m.standing}
      primary={m.primary}
      question={m.question}
      consequence={m.consequence}
      blocked={m.blocked}
      reversible={m.reversible}
      onPrimary={() => props.onAct(m.act!, m.itemId)}
      onAction={(id) => props.onReversible(id as Reversible['id'])}
    />
  );
}
